import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { ApplicationStore, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Dictionary, Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';

export interface ApplicationConfig {
  name: string;
  title: string;
  icon: string;
  route: string;
  permission?: string;
  color?: string;
  translations: Dictionary<object>;
  group?: { id: number; name: string };
}

export function registerApplication(appConfig: ApplicationConfig): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    const store = inject(Store);
    for (const [language, translations] of Object.entries(appConfig.translations)) {
      store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
        module: appConfig.name,
        language: language,
        translations: translations ?? {},
      });
    }

    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: appConfig.title,
      icon: appConfig.icon,
      route: appConfig.route,
      color: appConfig.color,
      routeParams: {
        fragment: undefined,
      },
      permission: appConfig.permission,
      group: appConfig.group,
    });
  });
}
